"use strict";

(function () {
  'use strict';

  angular.module('lr.services', ['lr.DataStream', 'lr.State', 'lr.Transactions', 'lr.Properties.Services', 'lr.services.socket-bridge', 'ga.service.analytics']);
})();